module.exports = __webpack_public_path__ + "static/media/7.841482d9.jpg";